import { PaymentMethod } from '../../types';

export function isPayPalPaymentMethodValid(paymentMethod: PaymentMethod): boolean {
    return !!paymentMethod.paymentMethodToken;
}
